<template>
  <el-breadcrumb class="breadcrumb-container">
    <el-breadcrumb-item v-for="item in breadcrumbList" :key="item.title">
      {{ item.title }}
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>

<script>
export default {
  name: 'Breadcrumb',
  computed: {
    breadcrumbList() {
      return this.$route.meta.breadcrumbs || [];
    },
  },
}
</script>

<style lang='scss' scoped>
.breadcrumb-container {
  padding: 15px 15px 0;
  box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/layout/breadcrumb.vue